import axios from 'axios';
import base_url from '../../../../main';
import https from "https";
import axiosRetry from 'axios-retry';

/**
 * If basket state changes, all states that rely on it also get updated.
 *
 * @returns {unknown}
 * @constructor
 */
const removeFromBasket = async (quoteItemId, associatedPlanId) => {
    const url = base_url['base_url'] + 'cart/remove';
    const config = {
        url: url,
        withCredentials: true,
        httpsAgent: new https.Agent({
            rejectUnauthorized: false
        }),
        method: 'post',
        data: {quoteItemId: quoteItemId, associatedPlanParent: associatedPlanId},
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        timeout: 3000
    };
    axiosRetry(axios, {
        retries: 6,
        shouldResetTimeout: true,
        retryDelay: axiosRetry.exponentialDelay,
    });
    return await axios.request(config);
}

export default removeFromBasket;